import { label } from "./labelHelper";

function hoursMinutesLabelArgs(timeInMinutes: number) {
  const hrs = Math.floor(timeInMinutes / 60);
  const mins = timeInMinutes % 60;

  let key = "";
  let values = [];

  if (hrs > 0) {
    values.push(hrs);
  }

  values.push(mins);

  if (hrs === 0 && mins === 0) {
    key = "minutes";
  }
  if (hrs === 0 && mins === 1) {
    key = "minute";
  }
  if (hrs === 0 && mins > 1) {
    key = "minutes";
  }
  if (hrs === 1 && mins === 0) {
    key = "hour";
  }
  if (hrs === 1 && mins === 1) {
    key = "hourMinute";
  }
  if (hrs === 1 && mins > 1) {
    key = "hourMinutes";
  }
  if (hrs > 1 && mins === 0) {
    key = "hours";
  }
  if (hrs > 1 && mins === 1) {
    key = "hoursMinute";
  }
  if (hrs > 1 && mins > 1) {
    key = "hoursMinutes";
  }

  return {
    key,
    values,
  };
}

export function hoursMinutesLabel(timeInMinutes: number) {
  let labelInfo = hoursMinutesLabelArgs(timeInMinutes);

  return timeInMinutes ? label(`${labelInfo.key}`, labelInfo.values) : "";
}

export function hoursMinutesLeftLabel(timeInMinutes: number) {
  let labelInfo = hoursMinutesLabelArgs(timeInMinutes);

  return timeInMinutes ? label(`${labelInfo.key}Left`, labelInfo.values) : "";
}
